var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title-l"},[_c('span',{staticClass:"title-line"}),_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"title-r"},[_vm._t("title-more")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }